import ICDocIcon from "@assets/icons/file-ic-memo.svg";
import CIMIcon from "@assets/icons/file-cim.svg";
import DocRegularIcon from "@assets/icons/file-doc-regular.svg";

import { DocumentType } from "@enums/common.enum";
import type { IDocumentTag } from "@interfaces/tag.interface";
import { TagLabel } from "@ui/Content";

type Props = {
  item: IDocumentTag;
} & React.HTMLAttributes<HTMLElement>;

export const SuggestionDocument = ({ item, ...rest }: Props) => {
  let Icon;
  switch (item.type) {
    case DocumentType.IC_MEMO:
      Icon = ICDocIcon;
      break;
    case DocumentType.CIM:
      Icon = CIMIcon;
      break;
    default:
      Icon = DocRegularIcon;
      break;
  }

  return (
    <div {...rest} className="flex min-w-0 cursor-pointer items-center gap-2 p-2">
      <Icon width={18} height={18} className="flex flex-shrink-0" />
      <TagLabel>{item.name}</TagLabel>
      <div className="flex flex-shrink-0 items-center gap-1 rounded-[5px] bg-[#F0F1F4] dark:bg-gray-600 p-0.5 pr-1 text-xs font-medium uppercase text-gray-950 dark:text-white">
        <span>{item.format}</span>
      </div>
    </div>
  );
};
